import { Status } from "../../../api/grpc/account/account";
import { Role } from "../../../api/grpc/contacts/account/account";
import {
  ContactsListRequest,
  ContactsListResponse,
  NullableBoolean,
  SortDirection,
  SortField,
} from "../../../api/grpc/contacts/contacts";
import { useContacts } from "../../../api/grpc/contacts/useContacts";
import useGrpcQuery from "../../../lib/hooks/useGrpcQuery";

interface ContactsParams {
  page: number;
  pageSize: number;
  name?: string;
  role?: Role[];
  status?: Status[];
  licensed?: NullableBoolean;
  desks?: NullableBoolean;
  sortDirection: SortDirection;
  sortField: SortField;
}

export const useGetContacts = ({
  page,
  pageSize,
  name,
  role,
  status,
  licensed,
  desks,
  sortDirection,
  sortField,
}: ContactsParams) => {
  const { getContacts } = useContacts();

  let hidePagination =
    !!name?.length ||
    !!role?.length ||
    !!status?.length ||
    licensed !== NullableBoolean.NULL ||
    desks !== NullableBoolean.NULL;

  const { loading, error, data, refetch } = useGrpcQuery<
    Omit<ContactsListRequest, "customerID">,
    ContactsListResponse
  >({
    method: getContacts,
    variables: {
      page: page,
      pageSize: hidePagination ? 0 : pageSize,
      name: name ?? "",
      role: role ?? [],
      status: status ?? [],
      licensed: licensed ?? NullableBoolean.NULL,
      desks: desks ?? NullableBoolean.NULL,
      sortDirection,
      sortField,
    },
  });

  return { loading, error, data, refetch };
};
